<template>
  <div>
    <page-title-bar :customTitle="customTitle"></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-toolbar :elevation="0" height="auto">
            <v-layout row justify-end align-center>
              <v-flex xs12 md8>
                <v-layout row class="ma-0 py-2">
                  <div>
                    <v-flex class="py-1">Tổng nợ</v-flex>
                    <v-flex class="py-1">Tổng có</v-flex>
                    <v-flex class="py-1">Net</v-flex>
                  </div>
                  <div>
                    <v-flex class="py-1 text-right">{{
                      this.total_debit | formatCurrency
                    }}</v-flex>
                    <v-flex class="py-1 text-right">{{
                      this.total_credit | formatCurrency
                    }}</v-flex>
                    <v-flex class="py-1 text-right">
                      {{
                        net_amount | formatCurrency
                      }}
                    </v-flex>
                  </div>
                </v-layout>
              </v-flex>
              <v-flex xs12 md4>
                <div style="max-width: 290px">
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu_month_picker"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    max-width="290px"
                    :disabled="loader"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="chosen_month"
                      label="Chọn tháng"
                      :disabled="loader"
                      prepend-icon="event"
                      readonly
                      hide-details
                    ></v-text-field>
                    <v-date-picker
                      min="2019-10"
                      locale="vi-VI"
                      type="month"
                      v-model="chosen_month"
                      @input="menu_month_picker = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </v-flex>
              <v-flex xs12 md2>
                <v-btn @click="exportCSV" color="green" dark :disabled="loader" class="mt-2">
                  <v-icon left>file_download</v-icon>
                  Xuất Excel
                </v-btn>
                <export-csv-button
                    :trigger="export_csv.trigger"
                    :title="export_csv.title"
                    :rows="export_csv.rows"
                ></export-csv-button>
              </v-flex>
            </v-layout>
          </v-toolbar>

          <div class="mt-3">
            <v-card>
              <v-data-table
                disable-initial-sort
                :headers="headers"
                :items="items"
                item-key="id"
                :rows-per-page-items="rowPerPage"
              >
                <template #items="props">
                  <tr>
                    <td class="text-no-wrap">
                      {{ props.item.bank_receipt_id }}
                    </td>
                    <td class="text-no-wrap">
                      {{ props.item.receipt_id }}
                    </td>
                    <td class="text-right text-no-wrap">
                      {{ props.item.date_created | formatTimeServer }}
                    </td>
                    <td class="text-right text-no-wrap">
                      {{ props.item.account_code }}
                    </td>
                    <td class="text-right text-no-wrap">
                      {{ props.item.account_correspondence_code }}
                    </td>
                    <td class="text-no-wrap">
                      {{ $options.filters.translateAccountingAccountToName(props.item.account_code, props.item.account) }}
                    </td>
                    <td class="text-no-wrap">
                      {{
                        $options.filters.translateAccountingAccountToName(props.item.account_correspondence_code, props.item.account_correspondence)
                      }}
                    </td>
                    <td class="text-right text-no-wrap">
                      {{ props.item.debit | formatCurrency }}
                    </td>
                    <td class="text-right text-no-wrap">
                      {{ props.item.credit | formatCurrency }}
                    </td>
                    <td class="text-right text-no-wrap">
                      {{ props.item.net | formatCurrency }}
                    </td>
                    <td class="text-no-wrap">
                      {{ props.item.room_id }}
                    </td>
                    <td class="text-no-wrap">
                      {{ props.item.description }}
                    </td>
                  </tr>
                </template>
                <template #no-data>
                  Chưa có thông tin
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <print-portal
      layout="portrait"
      :open="print_table"
      @close="print_table = false"
    >
      <print-so-tien-mat :items="items"></print-so-tien-mat>
    </print-portal>
  </div>
</template>

<script>
import moment from "moment";
import api from "Api";
import { formatTimeServer } from "Helpers";
import { buildParamQuery } from "Helpers";
import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton.vue'

export default {
  name: "so-tien-mat",
  components: {
    ExportCsvButton
  },
  data() {
    return {
      loader: false,
      headers: [
        {
          text: "Số chứng từ NH",
          align: "left",
          sortable: true,
          value: "bank_receipt_id",
        },
        {
          text: "Số chứng từ chi tiết",
          align: "left",
          sortable: true,
          value: "receipt_id",
        },
        {
          text: "Ngày",
          align: "right",
          sortable: true,
          value: "date_created",
        },
        {
          text: "TK",
          align: "right",
          sortable: true,
          value: "account_code",
        },
        {
          text: "TK Đối ứng",
          align: "right",
          sortable: true,
          value: "account_correspondence_code",
        },
        {
          text: "Tên TK",
          align: "left",
          sortable: true,
          value: "account",
        },
        {
          text: "Tên TK Đối ứng",
          align: "left",
          sortable: true,
          value: "account_correspondence",
        },
        {
          text: "Nợ",
          align: "center",
          sortable: true,
          value: "debit",
        },
        {
          text: "Có",
          align: "center",
          sortable: true,
          value: "credit",
        },
        {
          text: "Net",
          align: "center",
          sortable: true,
          value: "net",
        },
        {
          text: "Số phòng",
          align: "center",
          sortable: true,
          value: "room_id",
        },
        {
          text: "Diễn giải",
          align: "center",
          sortable: true,
          value: "description",
        },
      ],
      export_csv: {
        loader: false,
        trigger: false,
        title: "",
        rows: [],
      },
      items: [],
      print_table: false,
      rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
      menu_month_picker: false,
      chosen_month: new Date().toISOString().substring(0, 7),
      net_amount: 0,
      total_debit: 0,
      total_credit: 0,
      export_csv: {
        loading: false,
        trigger: false,
        title: "NhatKyChung",
        rows: []
      },
    };
  },
  watch: {
    chosen_month: function() {
      this.getData();
    },
  },

  mounted() {
    this.getData();
  },
  created() {},
  computed: {
    customTitle() {
      return "Nhật Ký Chung";
    },
  },
  methods: {
    getData: async function() {
      this.loader = true;

      const params = {
        dateStart: moment(this.chosen_month).format("YYYY-MM-01"),
        dateEnd: moment(this.chosen_month)
          .endOf("month")
          .format("YYYY-MM-DD"),
      };
      const query = buildParamQuery(params);
      const result = await api.getJournal(query);

      const { journals, summary : { totalDebit, totalCredit, netAmount } } = result.data;

      this.items = [];

      this.total_debit = totalDebit;

      this.total_credit = totalCredit;

      this.net_amount = netAmount;

      this.items = journals.slice(0);

      this.loader = false;
    },
    exportCSV: function() {
      this.export_csv.rows = this.items.map(journal => ({
        'Ngày hạch toán': new Date(journal.date_created).toLocaleDateString('vi-VN'),
        'Số chứng từ': journal.receipt_id || '',
        'Mã tài khoản': journal.account_code,
        'Tên tài khoản': journal.account,
        'Mã tài khoản đối ứng': journal.account_correspondence_code,
        'Tên tài khoản đối ứng': journal.account_correspondence,
        'Số tiền nợ': journal.debit,
        'Số tiền có': journal.credit,
        'Số dư': journal.net,
        'Số phòng': journal.room_id || '',
        'Diễn giải': journal.description || '',
        'Giao dịch ngân hàng': journal.bank_transaction_id || '',
        'Phiếu ngân hàng': journal.bank_receipt_id || '',
        'Bút toán đầu tiên': journal.isFirstEntry ? 'Có' : 'Không',
        'Ngày tạo': new Date(journal.createdAt).toLocaleDateString('vi-VN'),
        'Ngày cập nhật': journal.updatedAt ? new Date(journal.updatedAt).toLocaleDateString('vi-VN') : ''
      }));
      
      this.export_csv.rows.push({
        'Ngày hạch toán': '',
        'Số chứng từ': '',
        'Mã tài khoản': '',
        'Tên tài khoản': 'TỔNG CỘNG',
        'Mã tài khoản đối ứng': '',
        'Tên tài khoản đối ứng': '',
        'Số tiền nợ': this.total_debit,
        'Số tiền có': this.total_credit,
        'Số dư': this.net_amount,
        'Số phòng': '',
        'Diễn giải': '',
        'Giao dịch ngân hàng': '',
        'Phiếu ngân hàng': '',
        'Bút toán đầu tiên': '',
        'Ngày tạo': '',
        'Ngày cập nhật': ''
      });
      
      this.export_csv.trigger = !this.export_csv.trigger;
    },
  },
};
</script>
